import {
  createContext,
  FunctionComponent,
  PropsWithChildren,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";

export interface OfflineSites {
  hasOfflineSite: boolean;
  addOneOfflineSite: () => void;
  removeOneOfflineSite: () => void;
}

export const OfflineSiteContext = createContext<OfflineSites>({
  hasOfflineSite: false,
  addOneOfflineSite: () => {
    throw new Error();
  },
  removeOneOfflineSite: () => {
    throw new Error();
  },
});

export const OfflineSiteContextProvider: FunctionComponent<PropsWithChildren<unknown>> = ({ children }) => {
  const [nbOfflineSite, setNbOfflineSite] = useState(0);

  useEffect(() => {
    if (typeof caches === "undefined") {
      return;
    }
    caches.keys().then((cacheKeys) => {
      setNbOfflineSite(cacheKeys.filter((cacheKey) => cacheKey.includes("site-cache")).length);
    });
  }, []);

  const addOneOfflineSite = useCallback(() => setNbOfflineSite((value) => value + 1), [setNbOfflineSite]);
  const removeOneOfflineSite = useCallback(() => setNbOfflineSite((value) => value - 1), [setNbOfflineSite]);

  return (
    <OfflineSiteContext.Provider
      value={{
        hasOfflineSite: nbOfflineSite > 0,
        addOneOfflineSite,
        removeOneOfflineSite,
      }}
    >
      {children}
    </OfflineSiteContext.Provider>
  );
};

export const useOfflineSiteContext = () => useContext(OfflineSiteContext);
